export const comments_4322229 = {"data":{"data":[],"links":{}}}